import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Featurearea = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const features = [
    {
      title: "Best Business Solution",
      description: "Full-cycle development tailored to unique business needs",
      icon: (
        <svg className="w-12 h-12 text-[#1c74bb]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      )
    },
    {
      title: "Business Growth Planning",
      description: "Strategic, scalable solutions for long-term success",
      icon: (
        <svg className="w-12 h-12 text-[#1c74bb]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      )
    },
    {
      title: "Smart Automation & AI",
      description: "Reduce manual effort and drive intelligent decisions",
      icon: (
        <svg className="w-12 h-12 text-[#1c74bb]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    },
    {
      title: "User-Centric Design ",
      description: "Digital experiences that delight and engage customers",
      icon: (
        <svg className="w-12 h-12 text-[#1c74bb]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    }
  ];

  return (
    <section className="py-20 bg-gray-50 relative bg_image ">
      <div className="containers  px-4 text-center  mb-16" data-aos="fade-up">
        <span className="text-[#1C74BB] font-medium text-sm uppercase tracking-wider">Our Features</span>
        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-2">
          Empowering Businesses with Smart Solutions
        </h2>
        <p className="text-gray-600 mt-4 text-lg">
          With a diverse portfolio and decades of experience, we help businesses adapt, grow, and succeed in competitive markets. Our solutions are designed with strategy, security, and sustainability in mind
        </p>
      </div>

      <div className="containers mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-transparent hover:border-blue-200 group"
              data-aos="zoom-in"
              data-aos-delay={index * 200}
            >
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r bg-[#e8f1f8] rounded-full p-5 group-hover:from-blue-100 group-hover:to-blue-200 transition-all duration-500">
                  {feature.icon}
                </div>
              </div>

              <h3 className="text-xl text-center font-bold text-gray-800 mb-4 group-hover:text-[#1C74BB] transition-colors duration-300">
                {feature.title}
              </h3>

              <p className="text-gray-600 leading-relaxed text-center">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Featurearea;
